module.exports = __webpack_public_path__ + "static/media/Figure_S10.7a5880ae.png";